import { render, staticRenderFns } from "./Identification.vue?vue&type=template&id=0c49e86a&scoped=true&"
import script from "./Identification.vue?vue&type=script&lang=js&"
export * from "./Identification.vue?vue&type=script&lang=js&"
import style0 from "./Identification.vue?vue&type=style&index=0&id=0c49e86a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c49e86a",
  null
  
)

component.options.__file = "Identification.vue"
export default component.exports